const configInfomation = {
    vision: {
        getFunc: 'getFile',
        listLayout: 'VisionLayout',
        emptyLayout: 'ImageEmptyLayout',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'visionM'
        }
    },
    donation: {
        listLayout: 'DonationLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'supportM'
        }
    },
    donationHome: {
        listLayout: 'DonateHomeLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'supportHomeM'
        }
    },
    Introduction: {
        listLayout: 'IntroductionLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'introduceM'
        }
    },
    fatherBanner: {
        listLayout: 'BannerLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'fatherBannerM'
        }
    },
    newsBanner: {
        listLayout: 'BannerLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'newsBannerM'
        }
    },
    donateBanner: {
        listLayout: 'BannerLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'donateBannerM'
        }
    },
    fsBanner: {
        listLayout: 'BannerLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'fsBannerM'
        }
    },
    albumBanner: {
        listLayout: 'BannerLayout',
        emptyLayout: 'ImageEmptyLayout',
        getFunc: 'getFile',
        detailApiParamSet: {
            a_container_id: 1,
            a_container_type: 'albumBannerM'
        }
    },

}

export default {
    methods: {
        returnInformationConfig(type) {
            return configInfomation[type];
        }
    }
}